import { Suspense, lazy } from "react";
import { View } from "../../../types/PageInterfaces";

const AppCalendar = lazy(() => import("./AppCalendar"));

interface Props {
  pageID: string;
  view: View;
  query: any;
  parentViewID?: string;
}

export default function PageViewCalendar({
  view,
  pageID,
  query,
  parentViewID,
}: Props) {
  return (
    <Suspense>
      <AppCalendar
        view={view}
        pageID={pageID}
        topLevelQuery={query}
        parentViewID={parentViewID}
      />
    </Suspense>
  );
}
